import React from 'react';
import styled from 'styled-components';

import Link from 'components/basic/Link/Link';

import { socialLinksIconsList } from './socialLinksList';

const Ul = styled.ul`
  display: flex;
  padding-left: 0;
  margin: 0;
  list-style-type: none;
  align-items: center;
`;

const Li = styled.li`
  padding: 0 10px;
`;

const IconWrap = styled.div`
  padding: 2px 1px;
  > svg {
    display: block;
    border: none;
  }
`;

function SocialLinks() {
  return (
    <Ul>
      {socialLinksIconsList.map(item => (
        <Li key={item.name}>
          <Link href={item.link} color="grayText" title={item.name}>
            {item.icon ? <IconWrap>{item.icon}</IconWrap> : item.name}
          </Link>
        </Li>
      ))}
    </Ul>
  );
}

export default SocialLinks;
